import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/admin/organization-signups',
    name: 'adminOrganizationSignups',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "organization-signups" */
          './views/organization-signups.vue'
        )
      ),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // Check if user has permission to manage organizations
        if (store.getters['auth/canManageCompanies']()) {
          handleRoute()
        } else {
          next({ name: '404', params: { resource: 'Organization Signups' } })
        }
        function handleRoute() {
          store
            .dispatch('adminOrganizations/fetchLists')
            .then(() => {
              next()
            })
            .catch(() => {
              next({
                name: '404',
                params: { resource: 'adminOrganizationSignups' },
              })
            })
        }
      },
    },
  },
]
